/**
 * Utility functions for parsing error responses from Rails API
 */

/**
 * Extracts error message from Rails API error response
 * @param {Error} err - Error object with response.text property
 * @returns {string|null} - Extracted error message or null if parsing fails
 */
export function extractErrorMessage(err) {
  if (!err?.response?.text) {
    return null;
  }

  try {
    const errorResponse = JSON.parse(err.response.text);

    // Standard format: {errors: ["some error message"]}
    if (errorResponse?.errors?.[0]) {
      return errorResponse.errors[0];
    }
    // todo: check if there are other formats to account for
    // Rails nested validation format: {project: {widgets.document.file: ["should be less than 20MB"]}}
    if (errorResponse.project) {
      return extractNestedErrorMessage(errorResponse.project);
    }

    return null;
  } catch (parseError) {
    return null;
  }
}

/**
 * Extracts error message from Rails nested validation error object
 * @param {Object} projectErrors - Project validation errors object
 * @returns {string|null} - First error message found or null
 */
export function extractNestedErrorMessage(projectErrors) {
  const firstKey = Object.keys(projectErrors)[0];
  if (firstKey && Array.isArray(projectErrors[firstKey]) && projectErrors[firstKey][0]) {
    return projectErrors[firstKey][0];
  }
  return null;
}
